export default "__VITE_ASSET__Bc6r3t2m__"